<template>
  <q-card :class="{ colored }">
    <q-card-section>
      <q-card-section class="q-table__title">
        {{ title }}
      </q-card-section>

      <q-card-section>
        <charts :options="computedChart" />
      </q-card-section>
    </q-card-section>
  </q-card>
</template>

<script>
import { merge, cloneDeep } from 'lodash'

export default {
  props: {
    title: String,
    chartData: Object,
    colored: Boolean
  },

  computed: {
    customChartConfig() {
      const config = {
        title: null,
        chart: {
          height: 250
        },
        colors: ['#cdcdcd', '#7499b5'],
        plotOptions: {
          column: {
            pointWidth: 30
          }
        }
      }

      if (this.colored) {
        const axisStyle = {
          labels: {
            style: { color: 'white' }
          }
        }
        config.chart.backgroundColor = '#7499b5'
        config.xAxis = axisStyle
        config.yAxis = axisStyle
        config.plotOptions.column.borderWidth = 0
        config.series = [{ color: '#fff' }, { color: '#1b4a6c' }]
      }

      return config
    },

    computedChart() {
      return merge(cloneDeep(this.chartData), this.customChartConfig)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.colored {
  background-color $lm-light-cyan
  color white
}
</style>
